import { memo, useCallback, useMemo } from 'react';
import { StyleSheet, View, ViewProps } from 'react-native';
import { VoidCb } from '../../types/others';

type Props = {
  onPress?: VoidCb;
  onEnter?: VoidCb;
  onLeave?: VoidCb;
} & Pick<ViewProps, 'onLayout' | 'style' | 'children'>;

const TvPressable = memo<Props>(
  ({ onPress, onEnter, onLeave, style, ...props }) => {
    const s = useMemo(
      () => StyleSheet.compose(style, { cursor: 'pointer' }),
      [style],
    );
    const onPointerDown = useCallback(
      (e: PointerEvent) => {
        if (e.button !== 0) return;
        onPress?.();
      },
      [onPress],
    );

    return (
      <View
        {...props}
        //@ts-ignore
        onPointerDown={onPointerDown}
        onPointerEnter={onEnter}
        onPointerLeave={onLeave}
        style={s}
        tabIndex={-1}
        focusable={false}
        tvFocusable={false}
        isTVSelectable={false}
      />
    );
  },
);

export default TvPressable;
